import { GetDemoDashboardLinkResult } from "tech-health-assessment-sdk/dist";
import { api } from "../../../../../../../../../services/core-api-service";

class DemoDashboardGridItemService {
    public async getDemoDashboardLink(): Promise<GetDemoDashboardLinkResult> {
        return api.demo.getDemoDashboardLink()
    }
}

export const service = new DemoDashboardGridItemService()